import { render } from "./nemunav.vue?vue&type=template&id=72ad9356"
import script from "./nemunav.vue?vue&type=script&lang=js"
export * from "./nemunav.vue?vue&type=script&lang=js"

import "./nemunav.vue?vue&type=style&index=0&id=72ad9356&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__